import React from 'react';
import Modal from 'react-modal';
import PropTyeps from 'prop-types';
import config from "../config";

const style = {
  content: {
    width: '50%',
    top: '50%',
    left: '50%',
    bottom: 0,
    background: 'transparent',
    padding: 0,
    outline: 'none',
    border: 'none',
    overflow: 'visible',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    zIndex: 2000,
    backgroundColor: config.modalBackgroundColor,
  },
};

Modal.setAppElement('#root');

const VideoViewer = (props) => {
  const { video, close } = props;
  return (
    <Modal closeTimeoutMS={config.closeTimeoutMS} isOpen style={style} onRequestClose={close} portalClassName="video-modal">
      <video className="modal-content videoPopup" id="video-source" controls style={{ width: '100%', maxHeight: '450px' }}>
        <source src={video.url} />
      </video>
    </Modal>
  );
};

VideoViewer.propTypes = {
  video: PropTyeps.object.isRequired,
  close: PropTyeps.func.isRequired,
};

export default VideoViewer;



// WEBPACK FOOTER //
// ./src/components/VideoViewer.jsx